import React from 'react'
import { CommandInput } from 'cmdk'
import { Box } from 'rebass/styled-components'

import { ClearIcon, SearchIcon } from '../Icon'
import { selectSearchStyles } from './styles'

export interface SmartSelectSearchProps extends React.ComponentProps<typeof CommandInput> {
  placeholder: string
}

export const SmartSelectSearch = ({ onValueChange, placeholder, ...props }: SmartSelectSearchProps): JSX.Element => {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const [value, setValue] = React.useState('')
  const handleClear = () => {
    handleValueChange('')
    inputRef && inputRef.current && inputRef.current.focus()
  }
  const handleValueChange = (value: string) => {
    setValue(value)
    onValueChange && onValueChange(value)
  }
  return (
    <Box
      data-name="SmartSelectSearch"
      sx={{
        ...selectSearchStyles
      }}
    >
      <SearchIcon color="grey300" />
      <CommandInput
        ref={inputRef}
        value={value}
        onValueChange={handleValueChange}
        placeholder={placeholder}
        {...props}
      />
      {value && (
        <Box as="button" data-name="clear-search-button" onClick={handleClear}>
          <ClearIcon />
        </Box>
      )}
    </Box>
  )
}
